"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dialog = void 0;
const tailwind_merge_1 = require("tailwind-merge");
function Dialog({ children, className }) {
    return (<div className={(0, tailwind_merge_1.twMerge)('w-[90vw] flex flex-col justify-center py-10 sm:w-fit sm:px-20 rounded-sm drop-shadow-2xl shadow-2xl border-[1px] border-light-4 bg-dark-2 gap-4', className)}>
			{children}
		</div>);
}
exports.Dialog = Dialog;
